import React, { useState, useEffect } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
  Button,
  Form,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import Breadcrumbs from "components/Common/Breadcrumb"
import TableContainer from "components/Common/TableContainer"
import ClientForm from "./clientmodalform"
import {
  deleteUser,
  getAllAgentDetails,
  getAllBillingTypes,
  getCategory,
  getProjectStatus,
  getProjectStatusTotalHours,
} from "store/manageclient/action"
import SubCatmodalform from "./subCatmodalform"
import RejectModal from "../../../../src/components/Common/RejectModal"
import BootstrapTable from "react-bootstrap-table-next"
import { GridbranchBoolValue } from "../ManageTrackProfile/trackcols"
import UserForm from "./usermodalform"
import DeleteModal from "components/Common/DeleteModal"
import ProjectTable from "./ProjectTable"
import { getUsersList } from "store/userlist/action"
import TotalHoursSpent from "./TotalHoursSpent"
import { customStylesSelect } from "common/data/settings"
import Select from "react-select"
import ProjectUserForm from "./ProjectUserModal"

const Manage_Client = props => {
  const dispatch = useDispatch()
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isEditHours, setIsEditHours] = useState(false)
  const [userModel, setuserModel] = useState(false)
  const [selectedRow, setselectedRow] = useState({})
  const [selectedCategory, setselectedCategory] = useState({})
  const [subModel, setsubModel] = useState(false)
  const [pageSize, setpageSize] = useState(10)
  const [pageindex, setpageindex] = useState(0)
  const [Searchcategory, setSearchcategory] = useState(null)
  const [SearchSubCategory, setSearchSubCategory] = useState(null)
  const [emptySearchField, setemptySearchField] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteuser, setDeleteuser] = useState(false)
  const [billableType, setBillableType] = useState({})
  const [projectManagerId, setProjectManagerId] = useState({})
  const [usersForProject, setUsersForProject] = useState([])
  const [searchProjectstatus, setSearchProjectstatus] = useState({
    "id": 1,
    "statusname": "ACTIVE",
    "label": "ACTIVE",
    "value": 1
})
  const [showProjectUserModal, setShowProjectUserModal] = useState(false);
  const [activeProject, setActiveProject] = useState({});
  const [activeUser, setActiveUser] = useState({});
  const [isEditProjectUser, setIsEditProjectUser] = useState(false);

  const [agent, setAgent] = useState({
    id: 0,
    label: "Select Agent Name",
    Value: "Select Agent Name",
  })

  const [selectedProjectstatus, setSelectedProjectstatus] = useState({})

  //Delete category User
  const [categoryUserModal, setCategoryUserModal] = useState({})

  const companyid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data
    ?.companysetting?.companyid
  const userid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id
  const params = {
    categoryName: Searchcategory ? Searchcategory : "",
    subCategoryName: SearchSubCategory ? SearchSubCategory : "",
    companyid: companyid,
    userId: userid,
    pageNumber: 1,
    pageSize: pageSize,
    sortKey: "CategoryName",
    sortValue: "desc",
    projectstatusid: searchProjectstatus?.value
  }

  useEffect(() => {
    if (emptySearchField) {
      dispatch(getCategory(params))
    }
  }, [emptySearchField, SearchSubCategory, Searchcategory])

  // Handle API Call
  useEffect(() => {
    // Project Manager list includes both Manager and Admin roles.
    const projectManagerList = {
      pageNumber: 1,
      pageSize: 100,
      searchKey: "accessgroupname",
      searchValue: "Manager,Admin"
    };
    dispatch(getCategory(params))
    dispatch(getAllAgentDetails())
    dispatch(getAllBillingTypes())
    dispatch(getUsersList(projectManagerList))
    dispatch(getUsersList())
    dispatch(getProjectStatus())
  }, [])
 
  const handleDelete = () => {
    const data = {
      categoryUserId: deleteuser?.id,
      categoryId: deleteuser?.parentCategoryId,
    }
    dispatch(deleteUser(data, handleResponse))
  }
  const handleResponse = status => {
    if (status === "SUCCESS") {
      setCategoryUserModal(false)
      dispatch(getCategory(params))
    }
  }
  const {
    categorylist,
    updatecategorysuccess,
    updateUserCategory,
    updatesubCategory,
    companySetting,
    accessSetting,
    getallagentslist,
    getallbillingtypes,
    updateUserCategoryLink,
    updateUserlinks,
    projectManager,
    allUsersList,
    projectStatus,
    projectStatustotalhoursData,
  } = useSelector(state => ({
    categorylist: state?.manageclient?.categorylist,
    getallagentslist: state?.manageclient?.getallagentslist,
    getallbillingtypes: state?.manageclient?.getallbillingtypes,
    updatecategorysuccess: state?.manageclient?.updatecategory?.statusCode,
    updateUserCategory: state?.manageclient?.updateUserCategory?.statusCode,
    updatesubCategory: state?.manageclient?.updateSubCategory?.statusCode,
    companySetting: state?.Login?.userDetails?.data,
    accessSetting: state?.Login?.accessDetails?.data,
    updateUserCategoryLink: state?.manageclient?.updateUserCategory,
    updateUserlinks: state?.manageclient?.usercategorylinkSuccess?.statusCode,
    projectManager: state?.userlist?.userlist?.data,
    allUsersList: state?.userlist?.alluserslist?.data,
    projectStatus:
      state?.manageclient?.getallprojectststusSuccess?.projectStatus,
    projectStatustotalhoursData:
      state?.manageclient?.getallprojectsttustotalSuccess,
  }))
  
  const hideMainCategorybutton = accessSetting?.createMainCat;
  const hideSubCategorybutton = accessSetting?.createSubCat;
  const totalCounts = categorylist?.Count;
  const canPreviousPage = pageindex > 0;
  const canNextPage =
    pageSize === -1 ? page.length >= pageSize : pageindex < pageSize - 1;

  const MainCategoryName = companySetting?.MainCategory
  const SubCategoryName = companySetting?.SubCategory
  useEffect(() => {
    if ((updateUserCategory || updatesubCategory || updateUserlinks) === 200) {
      dispatch(getCategory(params));
    }
  }, [updateUserCategory, updatesubCategory, updateUserlinks])

  useEffect(() => {
    if (updatecategorysuccess === 200) {
      dispatch(getCategory(params));
    }
    if (
      SearchSubCategory?.length == 0 ||
      Searchcategory?.length == 0 ||
      SearchSubCategory?.length == undefined ||
      Searchcategory?.length == undefined
    ) {
      setpageindex(0)
    }
  }, [updatecategorysuccess, Searchcategory, SearchSubCategory])

  const HeaderFormater = column => {
    return <strong>{column.text}</strong>
  }

  const columns = React.useMemo(
    () => [
      {
        text: companySetting?.MainCategory + " Name",
        dataField: "categoryName",
        sort: true,
        filterable: true,
        style: { textAlign: "left" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "left" }
        },
      },
      {
        text: "Full Name",
        dataField: "fullName",
        sort: true,
        filterable: true,
        style: { textAlign: "left" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),

        // headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "left" }
        },
      },
      {
        text: "Suspend",
        dataField: "suspend",
        sort: true,
        filterable: true,
        style: { textAlign: "center" },

        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: (cellContent, row) => (
          <>
            {cellContent == true ? (
              <i className="mdi mdi-check-bold me-2 text-success " />
            ) : (
              <i className="mdi mdi-close-thick me-2 text-danger" />
            )}
          </>
        ),

        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Status",
        dataField: "status",
        sort: true,
        filterable: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: (cellContent, row) => (
          <>
            {cellContent == true ? (
              <i className="mdi mdi-check-bold me-2 text-success " />
            ) : (
              <i className="mdi mdi-close-thick me-2 text-danger" />
            )}
          </>
        ),

        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Open Link",
        dataField: "openLink",
        sort: true,
        filterable: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: (cellContent, row) => (
          <>
            {cellContent == true ? (
              <i className="mdi mdi-check-bold me-2 text-success " />
            ) : (
              <i className="mdi mdi-close-thick me-2 text-danger" />
            )}
          </>
        ),

        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Restricted Users",
        dataField: "restrictbyAssignedUser",
        sort: true,
        filterable: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: (cellContent, row) => (
          <>
            {cellContent == true ? (
              <i className="mdi mdi-check-bold me-2 text-success " />
            ) : (
              <i className="mdi mdi-close-thick me-2 text-danger" />
            )}
          </>
        ),

        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Project Creation",
        dataField: "subCategoryCreation",
        sort: true,
        filterable: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: (cellContent, row) => (
          <>
            {cellContent == true ? (
              <i className="mdi mdi-check-bold me-2 text-success " />
            ) : (
              <i className="mdi mdi-close-thick me-2 text-danger" />
            )}
          </>
        ),

        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Project Creation By Admin",
        dataField: "subCategoryAdminCreate",
        sort: true,
        filterable: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),

        formatter: (cellContent, row) => (
          <>
            {cellContent == true ? (
              <i className="mdi mdi-check-bold me-2 text-success " />
            ) : (
              <i className="mdi mdi-close-thick me-2 text-danger" />
            )}
          </>
        ),
        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        text: "Billing Problem Stop Work",
        dataField: "billingProblem",
        sort: true,
        filterable: true,
        style: { textAlign: "center" },
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),

        formatter: (cellContent, row, rowIndex) => {
          const checkboxId = `billing-checkbox-${rowIndex}`;
          const isChecked = !!cellContent; // Converts truthy/falsy to boolean

          return (
            <div className="checkbox-wrapper-11">
              <input
                type="checkbox"
                id={checkboxId}
                checked={isChecked}
                readOnly
              />
              <label htmlFor={checkboxId}>
                <span className="checkbox-custom"></span>
              </label>
            </div>
          );
        },
        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "120px", textAlign: "center" }
        },
      },
      {
        style: { textAlign: "center" },
        classes: "action-styles",
        disableFilters: true,
        filterable: true,
        sort: true,
        sortCaret: (order, column) => (
          <i
            className={order === "asc" ? "bx bx-sort-down" : "bx bx-sort-up"}
          ></i>
        ),
        formatter: (cellContent, row) => (
          <div role="buttton" style={{ cursor: "Pointer" }}>
            <div
              onClick={e => {
                handleEditGroup(row)
              }}
            >
              <span>
                <i
                  className={"mdi mdi-square-edit-outline md-squaree-edit"}
                  id="Edit"
                  style={{ fontSize: "16px" }}
                />
                <UncontrolledTooltip
                  placement="top"
                  target="Edit"
                  className="text-white"
                >
                  Edit
                </UncontrolledTooltip>
              </span>
            </div>
          </div>
        ),

        Cell: cellProps => {
          return <></>
        },

        headerFormatter: HeaderFormater,
        headerStyle: (colum, colIndex) => {
          return { width: "30px", textAlign: "center", pointerEvents: "auto" }
        },
      },
    ],
    []
  )

  const handleUserEdit = data => {
    if (data !== null) {
      setIsEdit(true)
      setselectedRow(data)
    } else {
      validation.resetForm()
      setIsEdit(false)
    }
    usertoggle()
  }

  const handleUserDelete = id => {
    setDeleteuser(id)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (deleteuser.id) {
      const data = {
        categoryUserId: deleteuser?.id,
        categoryId: deleteuser?.parentCategoryId,
      }
      dispatch(deleteUser(data, handleResponses))
    }
  }
  const handleResponses = status => {
    if (status === "SUCCESS") {
      setDeleteModal(false)
      dispatch(getCategory(params))
    }
  }
  const handleCancel = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  const handleUserCancel = () => {
    if (userModel) {
      setuserModel(false)
    } else {
      setuserModel(true)
    }
  }
  const usertoggle = () => {
    if (userModel) {
      setuserModel(false)
    } else {
      setuserModel(true)
    }
  }

  const ProjectUsertoggle = () => {
    setShowProjectUserModal((prevState) => !prevState);
  };
  
  const toggle = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  const handleUserClick = arg => {
    if (isEdit) {
      setAgent({
        id: 0,
        label: "Select Agent Name",
        Value: "Select Agent Name",
      })
    }
    setIsEdit(false)
    toggle()
  }
  const handleAddUser = arg => {
    setselectedCategory(arg)
    setIsEdit(false)
    usertoggle()
  }

  const handleEditGroup = data => {
    if (data !== null) {
      setIsEdit(true)
      setselectedRow(data)
    } else {
      validation.resetForm()
      setIsEdit(false)
    }
    toggle()
  }

  const handleSubEdit = data => {
    if (data !== null) {
      setIsEdit(true)
      setselectedRow(data)
    } else {
      validation.resetForm()
      setIsEdit(false)
    }
    subtoggle()
  }


  const handleSubEditTotalHours = data => {
    dispatch(getProjectStatusTotalHours(data?.id))
    if (data !== null) {
      setIsEditHours(true)
      
    } else {
      setIsEditHours(false)
    }
    subtoggleHours()
  }

  const handleSubCancel = () => {
    if (subModel) {
      setsubModel(false)
    } else {
      setsubModel(true)
    }
  }
  const subtoggle = () => {
    if (subModel) {
      setsubModel(false)
    } else {
      setsubModel(true)
    }
  }
  const subtoggleHours = () => {
    if (isEditHours) {
      setIsEditHours(false)
    } else {
      setIsEditHours(true)
    }
  }
  const handleAddSub = arg => {
    setselectedRow({})
    setProjectManagerId()
    setSelectedProjectstatus()
    setBillableType({
      label: "Please Select Billable Type",
      value: 0,
    })
    setIsEdit(false)
    subtoggle()
  }

  const handlePageValue = value => {
    setpageindex(0)
    if (!value.noChange) setpageindex(value.pageNumber)
    setpageSize(value.pageSize)
    dispatch(
      getCategory({
        ...value,
        pageNumber: value.pageNumber + 1,
        companyid: companyid,
        sortKey: "CategoryName",
        sortValue: "desc",
        categoryName: Searchcategory ? Searchcategory : "",
        subCategoryName: SearchSubCategory ? SearchSubCategory : "",
        projectstatusid: searchProjectstatus?.value
      })
    )
  }
  const handleSubmit = e => {
    setpageindex(0)
    e.preventDefault()
    const filterParams = {
      companyid: companyid,
      categoryName: Searchcategory ? Searchcategory : "",
      subCategoryName: SearchSubCategory ? SearchSubCategory : "",
      pagesize: pageSize,
      pageNumber:
        SearchSubCategory?.length == 0 ||
        Searchcategory?.length == 0 ||
        SearchSubCategory?.length == undefined ||
        Searchcategory?.length == undefined
          ? pageindex + 1
          : 1,
      sortKey: "categoryName",
      sortValue: "desc",
      projectstatusid: searchProjectstatus?.value
    }
    dispatch(getCategory(filterParams))
  }

  const usercolumns = React.useMemo(() => {
    const result = [
      {
        Header: "First Name",
        accessor: "firstName",
        disableFilters: true,
        sort: true,
        filterable: true,
      },
      {
        Header: "Last Name",
        accessor: "lastName",
        disableFilters: true,
        sort: true,
        filterable: true,
      },
      {
        Header: "Email",
        accessor: "email",
        disableFilters: true,
        sort: true,
        filterable: true,
      },
      {
        Header: "Country",
        accessor: "country",
        disableFilters: true,
        sort: true,
        filterable: true,
      },
      {
        Header: "Active",
        accessor: "active",
        disableFilters: true,
        sort: false,
        filterable: true,
        Cell: row => (
          <div style={{ paddingLeft: "15px" }}>
            {" "}
            <GridbranchBoolValue {...row} />{" "}
          </div>
        ),
      },

      {
        Header: "Report Recipient",
        accessor: "reportRecipient",
        disableFilters: true,
        sort: false,
        filterable: true,
        Cell: row => (
          <div style={{ paddingLeft: "40px" }}>
            {" "}
            <GridbranchBoolValue {...row} />{" "}
          </div>
        ),
      },

      {
        Header: "Action",
        sort: false,
        width: 50,
        Cell: cellProps => {
          return (
            <div role="buttton" style={{ cursor: "Pointer", paddingLeft: 10 }}>
              <UncontrolledDropdown>
                <DropdownToggle href="#" className="card-drop" tag="i">
                  <i className="mdi mdi-dots-vertical font-size-18" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem
                    href="#"
                    onClick={e => {
                      handleUserEdit(cellProps.row.original)
                    }}
                  >
                    Edit
                  </DropdownItem>
                  <DropdownItem
                    href="#"
                    onClick={el => {
                      handleUserDelete(cellProps.row.original)
                    }}
                  >
                    Delete
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ]
    return result
  }, [])

  const expandRow = {
    parentClassName: "table-primary bg-opacity-25",
    onlyOneExpanding: true,
    renderer: row => {
      row.categoryUsers.map(data => {
        data.parentCategoryId = row.categoryId
        return data
      })
      return (
        <>
          <div style={{ margin: "0 20px" }}>
            <TableContainer
              columns={usercolumns}
              data={row.categoryUsers || []}
              isGlobalFilter={false}
              isAddOptions={false}
              customPageSize={10}
              className="custom-header-css"
              hidepagination={true}
              buttonName={`Add New User`}
              isCategory={true}
              handleAddUser={() => handleAddUser(row)}
              handleUserEdit={handleUserEdit}
              hideMainCategorybutton={hideMainCategorybutton}
            />
          </div>
          <Modal isOpen={userModel} toggle={usertoggle}>
            <ModalHeader toggle={usertoggle} tag="h4">
              {isEdit ? "Edit Users" : "Create User"}
            </ModalHeader>
            <ModalBody>
              <UserForm
                handleUserCancel={handleUserCancel}
                selectedRow={selectedRow}
                isEdit={isEdit}
                toggle={usertoggle}
                categoryUsers={row}
                updateUserCategoryLink={updateUserCategoryLink}
                updateUserlinks={updateUserlinks}
                selectedCategory={selectedCategory}
              />
            </ModalBody>
          </Modal>
          <Modal isOpen={isEditHours} toggle={subtoggleHours}>
            <ModalHeader toggle={subtoggleHours} tag="h4">
              Total Hours Spent
            </ModalHeader>
            <ModalBody>
              <TotalHoursSpent data={projectStatustotalhoursData} />
            </ModalBody>
          </Modal>
          <Modal isOpen={subModel} toggle={subtoggle}>
            <ModalHeader toggle={subtoggle} tag="h4">
              {isEdit
                ? ` Edit ${companySetting?.SubCategory}`
                : ` Create ${companySetting?.SubCategory}`}
            </ModalHeader>
            <ModalBody>
              <SubCatmodalform
                isEdit={isEdit}
                handleCancel={handleSubCancel}
                toggle={subtoggle}
                selectedRow={selectedRow}
                companyid={companyid}
                companySetting={companySetting}
                getallbillingtypes={getallbillingtypes}
                selectedId={row.categoryId}
                setBillableType={setBillableType}
                billableType={billableType}
                projectManager={projectManager}
                setProjectManagerId={setProjectManagerId}
                projectManagerId={projectManagerId}
                users={allUsersList.map(el => {
                  return {
                    ...el,
                    label: `${el.firstname} ${el.lastname}`,
                    value: el.id,
                  }
                })}
                setUsersForProject={setUsersForProject}
                usersForProject={usersForProject}
                selectedProjectstatus={selectedProjectstatus}
                projectStatus={projectStatus}
                setSelectedProjectstatus={setSelectedProjectstatus}
              />
            </ModalBody>
          </Modal>
          <div style={{ margin: "0 20px" }}>
            <ProjectTable
              handleAddSub={handleAddSub}
              getallbillingtypes={getallbillingtypes}
              row={row}
              handleEditGroup={handleSubEdit}
              handleSubEditTotalHours={handleSubEditTotalHours}
              userModal={showProjectUserModal}
              setUserModal={setShowProjectUserModal}
              isEdit={isEditProjectUser}
              setIsEdit={setIsEditProjectUser}
              activeProject={activeProject}
              setActiveProject={setActiveProject}
              setActiveUser={setActiveUser}
            />
          </div>
        </>
      )
    },
    showExpandColumn: true,
    // onlyOneExpanding: true,
    expandColumnPosition: "right",
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      return <span />
    },
    // showExpandColumn: true
    expandColumnRenderer: ({ expanded, row }) => {
      if (expanded) {
        return <i className="bx bx-caret-up font-size-20"></i>
      }
      return <i className="bx bx-caret-down font-size-20"></i>
    },
  }
  const pageCount = Math.ceil(totalCounts / pageSize)

  const onChangeInSelect = event => {
    setpageSize(Number(event.target.value))
    handlePageValue({
      pageSize: Number(event.target.value),
      pageNumber: 0,
      // noChange: true,
    })
  }
  const handlenext = data => {
    // nextPage(data)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: pageindex + 1,
    })
  }
  const handleprev = () => {
    // previousPage()
    handlePageValue({
      pageSize: pageSize,
      pageNumber: pageindex - 1,
    })
  }
  const handlestartpage = () => {
    // gotoPage(0)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: 0,
    })
  }
  const handlelastpage = () => {
    // gotoPage(pageCount - 1)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: Math.ceil(totalCounts / pageSize) - 1,
    })
  }

  const onChangeInInput = event => {
    if (pageCount - 1 >= event.target.value) {
      const page = event.target.value > 0 ? Number(event.target.value) - 1 : 0
      // gotoPage(page)
      handlePageValue({
        pageSize: pageSize,
        pageNumber: page,
      })
    }
  }

    const selectData = [
    { value: null, label: 'ALL' },
    ...(projectStatus?.map(el => ({
      ...el,
      label: el.statusname,
      value: el.id,
    })) || [])
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <RejectModal
          show={!categoryUserModal}
          onDeleteClick={handleDelete}
          showText={"Are you sure want to Delete this User?"}
          confirmationText={"Yes, Delete"}
          onCloseClick={() => setCategoryUserModal(false)}
        />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteUser}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Container fluid>
          <Row>
            <Col xs="12">
              <Breadcrumbs
                title={` Manage ${companySetting?.MainCategory}`}
                breadcrumbItem={` Manage ${companySetting?.MainCategory}`}
              />
              <Card>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row className="manage_mobile">
                      <Col sm={3}>
                        <Input
                          type="text"
                          className="mb-2 me-1"
                          placeholder={`Search by ${MainCategoryName} `}
                          value={Searchcategory || ""}
                          onChange={e => {
                            setemptySearchField(false)
                            if (e.target.value === "") {
                              setemptySearchField(true)
                            }
                            setSearchcategory(e.target.value)
                          }}
                        />
                        <button
                          type="button"
                          className="close"
                          aria-label="Close"
                          style={{ marginTop: "-3px", marginRight: "10px" }}
                          onClick={
                            () =>
                              setemptySearchField(true) || setSearchcategory("")
                            //  || setselectedindex()
                          }
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </Col>
                      <Col sm={3}>
                        <Input
                          type="text"
                          className="mb-2 me-1"
                          placeholder={`Search by ${SubCategoryName}`}
                          value={SearchSubCategory || ""}
                          onChange={e => {
                            setemptySearchField(false)
                            if (e.target.value === "") {
                              setemptySearchField(true)
                            }
                            setSearchSubCategory(e.target.value)
                          }}
                        />
                        <button
                          type="button"
                          className="close"
                          aria-label="Close"
                          style={{ marginTop: "-3px", marginRight: "10px" }}
                          onClick={
                            () =>
                              setemptySearchField(true) ||
                              setSearchSubCategory("")
                            // || setselectedindex()
                          }
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </Col>
                      <Col sm={3} >
                      <Select
                        styles={customStylesSelect}
                        classNamePrefix="select2-selection"
                        value={searchProjectstatus}
                        onChange={value => setSearchProjectstatus(value)}
                        placeholder={"Project Status"}
                        options={selectData != undefined ?[ { value: '', label: 'Search By Project Status...', isDisabled: true },...selectData] :[]}
                      />
                      </Col>
                      <Col sm={1}>
                        <button
                          type="submit"
                          className="btn btn-primary save-customer"
                          onClick={handleSubmit}
                        >
                          Search
                        </button>
                      </Col>
                      {hideSubCategorybutton && (
                        <Col>
                          <div className="text-sm-end ">
                            <Button
                              type="button"
                              color="primary"
                              className="btn mb-2 me-2"
                              onClick={handleUserClick}
                            >
                              <i className="mdi mdi-plus-circle-outline me-1" />
                              {` Add New ${companySetting.MainCategory}`}
                            </Button>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Form>
                  <BootstrapTable
                    keyField="categoryId"
                    data={categorylist?.data || []}
                    columns={columns}
                    expandRow={expandRow}
                    headerClasses="table-light"
                    defaultSortDirection="asc"
                    noDataIndication="Sorry, There are no data to display"
                  />
                  {totalCounts !== 0 && (
                    <div className="pagination justify-content-end customiz_pagination">
                      <Col sm={2} className="me-3 p-2">
                        <select
                          className="form-select p-2"
                          value={pageSize}
                          onChange={onChangeInSelect}
                        >
                          {[10, 20, 30, 40, 50].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                              Show {pageSize}
                            </option>
                          ))}
                        </select>
                      </Col>

                      <div className="paginations d-flex justify-content-end align-items-center">
                        <Container>
                          <Row className=" align-items-center">
                            <Col className="col-md-auto">
                              <div className="d-flex gap-1">
                                <Button
                                  color="primary"
                                  onClick={handlestartpage}
                                  disabled={!canPreviousPage}
                                >
                                  {"<<"}
                                </Button>{" "}
                                <Button
                                  color="primary"
                                  onClick={handleprev}
                                  disabled={!canPreviousPage}
                                >
                                  {"<"}
                                </Button>{" "}
                              </div>
                            </Col>
                            <Col className="col-md-auto d-none d-md-block">
                              <span>
                                Page{" "}
                                <strong>
                                  {pageindex + 1} of{" "}
                                  {Math.ceil(totalCounts / pageSize)}
                                </strong>{" "}
                              </span>
                            </Col>
                            <Col className="col-md-auto">
                              <span>
                                | Go to page:{" "}
                                <input
                                  type="number"
                                  value={pageindex + 1}
                                  onChange={onChangeInInput}
                                  style={{ width: "50px", textAlign: "center" }}
                                />
                              </span>
                            </Col>
                            <Col className="col-md-auto">
                              <div className="d-flex gap-1">
                                <Button
                                  color="primary"
                                  onClick={handlenext}
                                  disabled={
                                    !canNextPage ||
                                    pageindex >=
                                      Math.ceil(totalCounts / pageSize) - 1
                                  }
                                >
                                  {">"}
                                </Button>{" "}
                                <Button
                                  color="primary"
                                  onClick={handlelastpage}
                                  disabled={
                                    !canNextPage ||
                                    pageindex >=
                                      Math.ceil(totalCounts / pageSize) - 1
                                  }
                                >
                                  {">>"}
                                </Button>{" "}
                              </div>
                            </Col>
                          </Row>
                        </Container>
                      </div>
                    </div>
                  )}
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {isEdit
                        ? ` Edit ${companySetting.MainCategory}`
                        : ` Create ${companySetting.MainCategory}`}
                    </ModalHeader>
                    <ModalBody>
                      <ClientForm
                        companyid={companyid}
                        getallagentslist={getallagentslist}
                        isEdit={isEdit}
                        handleCancel={handleCancel}
                        toggle={toggle}
                        selectedRow={selectedRow}
                        companySetting={companySetting}
                        agent={agent}
                        setAgent={setAgent}
                      />
                    </ModalBody>
                  </Modal>
                  <ProjectUserForm
                    show={showProjectUserModal}
                    toggle={ProjectUsertoggle}
                    selectedProject={activeProject}
                    activeUser={activeUser}
                    isEdit={isEditProjectUser} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Manage_Client
